export const REPLAY_DISCOVERY_CLICK_LIMIT = 3;

const storageKey = (userId: string) => `byb:replay-hint-clicks:${userId}`;

export const readReplayHintClickCount = (userId: string): number => {
  try {
    const count = Number(localStorage.getItem(storageKey(userId)));
    return Number.isFinite(count) ? Math.min(REPLAY_DISCOVERY_CLICK_LIMIT, Math.max(0, Math.floor(count))) : 0;
  } catch {
    return 0;
  }
};

export const recordLocalReplayHintClick = (userId: string, currentCount: number): number => {
  const count = Math.min(REPLAY_DISCOVERY_CLICK_LIMIT, Math.max(currentCount, readReplayHintClickCount(userId)) + 1);
  try {
    localStorage.setItem(storageKey(userId), String(count));
  } catch {
    // The hint still dismisses for this screen when headset storage is unavailable.
  }
  return count;
};
